module.exports = __webpack_public_path__ + "img/rongyu_en.ec863968.png";